import { Box, Container, Heading } from '@chakra-ui/react';

import React from 'react';
import { LinkPhone } from '../_index';

const CalloutPhoneNumber = () => (
  <Container
    maxW="container.xl"
    py={10}
  >
    <Box display={{ base: 'none', sm: 'block' }}>
      <Heading
        textAlign="center"
        as="h4"
        size="3xl"
      >
        Give us a Call:
        {' '}
        <LinkPhone ml={4}>510.900.8770</LinkPhone>
      </Heading>
    </Box>
    <Box display={{ base: 'block', sm: 'none' }}>
      <Heading
        textAlign="center"
        as="h4"
        size="2xl"
      >
        Give us a Call:
        {' '}
        <LinkPhone ml={4}>510.900.8770</LinkPhone>
      </Heading>
    </Box>
  </Container>
);

export default CalloutPhoneNumber;
